import * as tslib_1 from "tslib";
import moveMailListRowsHelper from './helpers/moveMailListRowsHelper';
import { action } from 'satcheljs/lib/legacy';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import moveItemsFromItemIds from 'owa-mail-triage-action/lib/actions/move/moveItemsFromItemIds';
/**
 * The action worker which handles moving conversations.
 * @param conversationIds - the conversations that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the conversations are moving from
 */
export default action('moveItems')(function moveItems(rowKeys, destinationFolderId, originalTableView, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, moveMailListRowsHelper(rowKeys, destinationFolderId, originalTableView, moveItemsInternal, actionSource)];
        });
    });
});
/**
 * The move items internal method
 * @param rowKeys - the row keys of the rows that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
function moveItemsInternal(rowKeys, destinationFolderId, originalTableView, sourceFolderId, actionSource) {
    var itemIdStrings = getRowIdsFromRowKeys(rowKeys, originalTableView.id);
    moveItemsFromItemIds(itemIdStrings, destinationFolderId, originalTableView, actionSource);
}
//# sourceMappingURL=moveItems.js.map